/* eslint-disable no-prototype-builtins */
import React, { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import axios from 'axios'
import { Link } from 'react-router-dom'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import { swipelyticsTurquoise, swipelyticsPink, positionChangeWidthSm, navbarHeight, footerHeight, demoUsersArray, testProductImageDimension } from '../../helpers/variableDefaults'
import { seoPageTags, registerPageViewsInsideMetaBrowser, runGTAGScript } from '../../helpers/analytics'
import { standardSpinner } from '../../helpers/spinners'
import { shuffleArray, dummyBoxWidth, isInstagramOrFacebook } from '../../helpers/globalHelpers' 
import { standardButton } from '../../helpers/buttons'
import useWindowDimensions from '../../helpers/windowDimensions'


// Demo Page
const Demo = ({ fromHomepage = false }) => {

  // use Naviage
  const navigate = useNavigate()

  // Window Dimensions
  const { height, width } = useWindowDimensions()

  // URL Path
  const urlPath = window.location.pathname
  // console.log('urlPath ->', urlPath)

  // States
  const [shuffledDemoUsersArray, setShuffledDemoUsersArray] = useState(fromHomepage ? shuffleArray([ ...demoUsersArray.slice(0, 2) ]) : shuffleArray([ ...demoUsersArray ]).slice(0, 10))
  // console.log('shuffledDemoUsersArray ->', shuffledDemoUsersArray)
  const [userSelectedIndex, setUserSelectedIndex] = useState(0) 


  useEffect(() => {
    const checkForMetaBrowser = () => {
      if (isInstagramOrFacebook()) {

        const timeout = setTimeout(() => {
          // console.log('⏱️ Delayed effect: 250ms later');
          // Put your delayed logic here
          registerPageViewsInsideMetaBrowser('Demo')
        }, 250) // delay in milliseconds

        return () => clearTimeout(timeout)
      }
    }
    
    checkForMetaBrowser()
  }, [])

  // Use Effects
  useEffect(() => {
    // console.log('estatesArray useEffect runs')
    // console.log('estatesArray event ->', estatesArray[estateSelectedIndex].event[0])
    
  }, [shuffledDemoUsersArray])

  useEffect(() => {
    // console.log('estateSelectedIndex useEffect runs')
    // console.log('estatesArray event ->', estatesArray[estateSelectedIndex].event[0])
    

  }, [userSelectedIndex])

  const handleSelectDemoUser = async (userIndex) => {
    // console.log('handleSelectEstate runs')
    // console.log('distribution method previous selection ->', estatesArray[estateSelectedIndex].event[0].distributionMethod)

    setUserSelectedIndex(userIndex)

  }

  const handleStartDemo = async () => {
    // console.log('handleStartDemo runs')

    window.scrollTo(0, 0)

    const firstNameLowerCase = shuffledDemoUsersArray[userSelectedIndex].bio.vitalInfo.firstName.toLowerCase()
    const genderLowerCase = shuffledDemoUsersArray[userSelectedIndex].bio.vitalInfo.gender.toLowerCase()

    const reviewerFirstName = firstNameLowerCase === 'carrie' ? 'mrbig' : firstNameLowerCase === 'ted' ? 'robin' : firstNameLowerCase === 'hermione' ? 'ron' : (firstNameLowerCase === 'ron' || firstNameLowerCase === 'harry' || firstNameLowerCase === 'albus') ? 'hermione' : (firstNameLowerCase === 'miranda' || firstNameLowerCase === 'charlotte' || firstNameLowerCase === 'samantha') ? 'carrie' : firstNameLowerCase === 'george' ? 'elaine' : firstNameLowerCase === 'leon' ? 'larry' : (firstNameLowerCase === 'elaine') ? 'jerry' : (firstNameLowerCase === 'cosmo') ? 'george' : ((firstNameLowerCase === 'robin' && genderLowerCase === 'female') || firstNameLowerCase === 'barney') ? 'ted' : (firstNameLowerCase === 'jay') ? 'holly' : (firstNameLowerCase === 'frodo') ? 'luigi' : firstNameLowerCase === 'rachel' ? 'monica' : firstNameLowerCase === 'larry' ? 'leon' : (firstNameLowerCase === 'holly') ? 'jay' : (firstNameLowerCase === 'luigi') ? 'frodo' : firstNameLowerCase === 'monica' ? 'rachel' : 'error'

    const profileTypeLowerCase = (firstNameLowerCase === 'leon' || firstNameLowerCase === 'larry' || firstNameLowerCase === 'holly') ? 'tinder' : (firstNameLowerCase === 'elaine' || firstNameLowerCase === 'frodo') ? 'bumble' : 'hinge'

    // navigate(`/demo/${shuffledDemoUsersArray[userSelectedIndex].bio.vitalInfo.firstName.toLowerCase()}/dashboard`)
    // console.log('fromHomepage ->', fromHomepage)
    navigate(`/demo/${firstNameLowerCase}/${profileTypeLowerCase}/${reviewerFirstName}/view-feedback${fromHomepage ? `?homepage` : ``}`, { state: { previousLocationPathname: fromHomepage ? `${window.location.pathname}?homepage` : `${window.location.pathname}` } })
  }

  return (
    <>
      {/* Helmet — for analytics, seo, and page title changing */}
      {
        // !isInstagramOrFacebook() ?
        !fromHomepage
          ?
          seoPageTags(
            'Demo'
          )
          :
          <></>
        // :
        // runGTAGScript()
      }

      {/* Body */}
      <Box 
        sx={{ 
          minHeight: fromHomepage ? 0 : `calc(100vh - ${navbarHeight} - ${footerHeight})`, 
          // backgroundColor: fromHomepage ? 'darkgray' : '',
          backgroundColor: fromHomepage ? 'whitesmoke' : '',
          width: '100vw', 
          display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center', 
        }}
      >
        {/* Select User */}
        <Box 
          sx={{ 
            mt: (width > positionChangeWidthSm && !fromHomepage) ? 4 : 0, mb: (width > positionChangeWidthSm && !fromHomepage) ? 4 : 0,
            py: fromHomepage ? 6 : 2,
            backgroundColor: fromHomepage ? '' : 'whitesmoke',
            width: '100%',
            maxWidth: fromHomepage ? '600px' : '600px', 
            boxShadow: fromHomepage ? 0 : 3,
            borderRadius: (width < positionChangeWidthSm || fromHomepage) ? 0 : 5,
            display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center', 
          }}
        >
          {/* Title */}
          <Box 
            sx={{ 
              mb: 2,
              width: '95%',
              fontSize: '20px',
              fontWeight: 'bold',
              display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', 
            }}
          >
            Select Your Avatar
          </Box>

          {/* Users */}
          
          <Box 
            sx={{ 
              width: '95%',
              display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center',
              flexWrap: 'wrap',
            }}
          >
            {shuffledDemoUsersArray.length > 0 && shuffledDemoUsersArray.map((user, userIndex) => (
              <Box
                key={userIndex}
                onClick={() => handleSelectDemoUser(userIndex)}
                sx={{
                  my: 1, mx: 2,
                  py: 1,
                  backgroundColor: 'white',
                  width: '100%',
                  maxWidth: '200px',
                  boxShadow: 3,
                  borderRadius: 5,
                  cursor: 'pointer',
                  border: userSelectedIndex === userIndex ? '2px solid #2979ff' : '0px solid #2979ff',
                  display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
                }}
              >
                {/* Image */}
                <Box component='img' src={user.media[0].url} alt='Avatar Image' 
                  sx= {{ 
                    ml: 1, mr: 1,
                    height: testProductImageDimension, width: testProductImageDimension, objectFit: 'cover', boxShadow: 2, 
                  }} 
                /> 

                {/* Title */}
                <Box
                  textAlign={'center'}
                  sx={{
                    // backgroundColor: 'yellow',
                    pt: 1, pb: 1,
                    width: '95%',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    display: '-webkit-box',
                    WebkitLineClamp: '1',
                    WebkitBoxOrient: 'vertical',
                  }}
                >
                  {`${user.bio.vitalInfo.firstName}, ${user.bio.vitalInfo.age}, ${user.bio.vitalInfo.sexuality}`}
                </Box>

              </Box>
            ))}

            {!fromHomepage && width > positionChangeWidthSm && shuffledDemoUsersArray.length % 2 > 0 &&
              dummyBoxWidth('200px', 2)
            }

          </Box>
          {/* Start Button */}
          <Box
            sx={{
              // pl: 2,
              pt: 2,
              width: '100%', 
              display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
            }}
          >
            {standardButton(
              `See Review`, 
              'button',
              'contained',
              false,
              fromHomepage ? 'primary' : 'primary', 
              0,
              2,
              0,
              '180px', 
              '50px', 
              handleStartDemo
            )}
          </Box>
        </Box>

        {/* Start Button */}
        {/* <Box
          sx={{
            // pl: 2,
            pt: 2,
            width: '100%', 
            display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
          }}
        >
          {standardButton(
            `See Review`, 
            'button',
            'contained',
            false,
            'primary', 
            0,
            2,
            0,
            '180px', 
            '50px', 
            handleStartDemo
          )}
        </Box> */}

      </Box>
    </>
  )
}

export default Demo